import type { ReviewCaseView } from '../product-review/adapters/product-review-port';
import './content-media.css';

export function reviewDecisionLabel(outcome?: string | null) {
  return outcome === 'ACCEPTED'
    ? '审核通过'
    : outcome === 'CHANGES_REQUESTED'
      ? '退回修改'
      : '尚未决定';
}

/** Summary is derived from the exact submitted declaration, never the current mutable draft. */
export function ReviewSummary({
  review,
  name,
  decisionTarget,
}: {
  review: ReviewCaseView;
  name: string;
  decisionTarget: string;
}) {
  return (
    <header className="cm-review-summary">
      <div className="cm-section-heading">
        <span className="cm-eyebrow">
          {review.submitted.subjectKind === 'LOCAL_ASSET'
            ? '本地装备审核 · 05'
            : '产品型号审核 · 06'}
        </span>
        <span
          className={`cm-review-status ${review.decision?.outcome === 'ACCEPTED' ? 'is-accepted' : ''}`}
        >
          {reviewDecisionLabel(review.decision?.outcome)}
        </span>
      </div>
      <h2>{name}</h2>
      <dl className="cm-summary-facts">
        <div>
          <dt>提交修订</dt>
          <dd>r{review.submitted.revision}</dd>
        </div>
        <div>
          <dt>所属范围</dt>
          <dd>
            {review.submitted.country} / {review.submitted.ownerScope}
          </dd>
        </div>
        <div>
          <dt>审核范围</dt>
          <dd>{review.submitted.reviewScope}</dd>
        </div>
      </dl>
      <a className="cm-decision-link" href={`#${decisionTarget}`}>
        查看审核决定与下一步 ↓
      </a>
      <details className="cm-audit">
        <summary>对象标识、版本与来源证据</summary>
        <dl>
          <dt>审核编号</dt>
          <dd>{review.caseId}</dd>
          <dt>对象 ID</dt>
          <dd>{review.submitted.subjectId}</dd>
          <dt>提交账号 / 审核 CAS 版本</dt>
          <dd>
            {review.submitted.makerAccount} / {review.version}
          </dd>
          <dt>完整来源键</dt>
          <dd>{review.submitted.sourceEvidence ?? 'UNAVAILABLE'}</dd>
          <dt>提交摘要 SHA-256</dt>
          <dd>
            <code>{review.submitted.digest}</code>
          </dd>
        </dl>
      </details>
    </header>
  );
}

export function priorReview(cases: readonly ReviewCaseView[], selected: ReviewCaseView | null) {
  if (!selected) return undefined;
  return [...cases]
    .filter(
      (c) =>
        c.submitted.subjectKind === selected.submitted.subjectKind &&
        c.submitted.subjectId === selected.submitted.subjectId &&
        c.submitted.country === selected.submitted.country &&
        c.submitted.ownerScope === selected.submitted.ownerScope &&
        c.submitted.reviewScope === selected.submitted.reviewScope &&
        c.submitted.revision < selected.submitted.revision,
    )
    .sort((a, b) => b.submitted.revision - a.submitted.revision)[0];
}
